// extracted by mini-css-extract-plugin
export default {"languageContainer":"Technologies_languageContainer__nm4eA","icon":"Technologies_icon__ZzdVY"};